import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.ts";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.ts";
import { type BaseStepStore } from "#src/types/StepStore.ts";
import { computed } from "vue";
import { type Pinia, type StoreGeneric } from "pinia";

function initializeLoginStep(pinia: Pinia): BaseStepStore {
  const step = computed(() => STEP.LOGIN);
  const next = computed(() => null);
  const previous = computed(() => null);
  const hidesFooter = computed(() => true);
  const skipStepSave = computed(() => true);
  const hidesShare = computed(() => true);
  const hidesHeader = computed(() => {
    const instance = useInstanceSettingsStore(pinia);
    return instance.chat || instance.use_modal || instance.use_webapp;
  });

  function $reset() {}

  return {
    $reset,
    step,
    next,
    previous,
    hidesFooter,
    skipStepSave,
    hidesShare,
    hidesHeader,
  };
}

export const useStepLoginStore = (pinia: Pinia, hot?: StoreGeneric) => {
  return defineStore<string, BaseStepStore>("step-login", () => {
    return initializeLoginStep(pinia);
  })(pinia, hot);
};
